import CancelPolicyPage from './CancelPolicyPage';

export default CancelPolicyPage;
